import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Page from '../page';
import MPHeader from './mp-header';
import { choosePath, emailPath } from '../helpers';
import Footer from '../footer';

export default class Create extends Component {
  state = {
    submitted: false
  };
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      submitted: true
    });

    const {
      userInput: { question_answer },
      setUserInput
    } = this.props;
    const qa_input = document.querySelector('#question_answer');
    if (qa_input !== null && question_answer === null) {
      setUserInput({ question_answer: false });
    }

    if (
      this.props.talkingPoints === null ||
      this.props.userInput.selectedTalkingPointsIds.length > 0
    ) {
      this.props.generateAndSetEmailMessage();
      this.props.history.push(
        emailPath({
          mp: this.props.selectedMP.id,
          electorate: this.props.selectedElectorateId,
          party: this.props.selectedPartyId
        })
      );
    }
  }

  render() {
    const {
      title,
      lead,
      mps,
      customMPDetails,
      parties,
      electorates,
      require_postal_address,
      talkingPoints,
      personalMessagePlaceholder,
      question,
      hideLookupStep,
      totalSteps,
      userInput: {
        selectedElectorateId,
        selectedPartyId,
        selectedMPId,
        firstName,
        lastName,
        email,
        postal_address,
        selectedTalkingPointsIds,
        personalMessage,
        question_answer
      },
      setUserInput
    } = this.props;

    if (!selectedMPId) {
      return (
        <Redirect
          to={choosePath({
            electorate: selectedElectorateId,
            party: selectedPartyId
          })}
        />
      );
    }

    const selectedMP = mps.find((mp) => mp.id === selectedMPId);
    const selectedMPParty = parties.find((p) => p.id === selectedMP.partyId);
    const selectedMPElectorate = electorates.find(
      (e) => e.id === selectedMP.electorateId
    );
    const customDetails = customMPDetails.find(
      (c) => c.table.mp_id === selectedMPId
    );
    const summary =
      customDetails && customDetails.table.summary
        ? customDetails.table.summary
        : selectedMP.summary;
    const bio =
      customDetails && customDetails.table.bio
        ? customDetails.table.bio
        : selectedMP.bio;

    const showSelectedTalkingPointsError =
      this.state.submitted &&
      (talkingPoints ? selectedTalkingPointsIds.length === 0 : false);

    const infoPanel = (
      <React.Fragment>
        <div className="mb-1">
          <h3 className="h4">About {selectedMP.name}</h3>
          <p>{summary}</p>
          <div dangerouslySetInnerHTML={{ __html: bio }} />
          {customDetails && customDetails.table.content && (
            <div
              dangerouslySetInnerHTML={{
                __html: customDetails.table.content
              }}
            />
          )}
        </div>
      </React.Fragment>
    );

    const footer = (
      <Footer
        step={hideLookupStep ? 2 : 3}
        totalSteps={totalSteps}
        left={
          <Link
            to={choosePath({
              electorate: selectedElectorateId,
              party: selectedPartyId
            })}
            className="btn btn-outline-redpink btn-block"
          >
            ← Choose
          </Link>
        }
        right={
          <button type="submit" className="btn btn-redpink btn-block">
            Preview →
          </button>
        }
      />
    );

    const qa_field = (
      <React.Fragment>
        <div className="form-group form-check mt-2">
          <div className="mb-2">
            <input
              id="question_answer"
              name="question_answer"
              type="checkbox"
              className="form-check-input"
              value="yes"
              checked={question_answer === true}
              onChange={(event) =>
                setUserInput({ question_answer: event.target.checked })
              }
            />
            <label className="form-check-label ml-1" htmlFor="question_answer">
              {question}
            </label>
          </div>
        </div>
      </React.Fragment>
    );

    const postal_address_field = (
      <React.Fragment>
        <div className="form-group">
          <label className="h5" htmlFor="postal_address">
            Postal Address
          </label>

          <input
            id="postal_address"
            name="postal_address"
            type="text"
            className="form-control form-control-sm"
            required
            value={postal_address}
            onChange={(event) =>
              setUserInput({ postal_address: event.target.value })
            }
          />
        </div>
      </React.Fragment>
    );

    return (
      <form onSubmit={this.handleSubmit}>
        <Page
          title={title}
          lead={lead}
          infoPanel={infoPanel}
          header={
            <MPHeader
              mp={selectedMP}
              party={selectedMPParty}
              electorate={selectedMPElectorate}
            />
          }
          footer={footer}
        >
          <p>
            Now it's time to craft your message! Answer these questions, and
            we'll create a draft message that you can preview and edit before
            you send in the next step.
          </p>
          <div className="form-row">
            <div className="form-group col-6">
              <label className="h5" htmlFor="firstName">
                First name
              </label>
              <input
                id="firstName"
                name="firstName"
                type="text"
                className="form-control form-control-sm"
                required
                value={firstName}
                onChange={(event) =>
                  setUserInput({ firstName: event.target.value })
                }
              />
            </div>
            <div className="form-group col-6">
              <label className="h5" htmlFor="lastName">
                Last name
              </label>
              <input
                id="lastName"
                name="lastName"
                type="text"
                className="form-control form-control-sm"
                required
                value={lastName}
                onChange={(event) =>
                  setUserInput({ lastName: event.target.value })
                }
              />
            </div>
          </div>

          <div className="form-group">
            <label className="h5" htmlFor="email">
              Email Address
            </label>
            <input
              id="email"
              name="email"
              type="email"
              aria-describedby="emailHelpBlock"
              className="form-control form-control-sm"
              required
              value={email}
              onChange={(event) => setUserInput({ email: event.target.value })}
            />
          </div>

          {require_postal_address ? postal_address_field : ''}

          <div className="form-group">
            <small id="emailHelpBlock" className="form-text text-muted mt-3">
              ActionStation will contact you about this and similar campaigns.
              You can opt out at anytime. Read{' '}
              <a href="http://www.actionstation.org.nz/privacy_policy">
                ActionStation's privacy policy here.
              </a>
            </small>
          </div>

          {talkingPoints && (
            <fieldset>
              <legend className="h5">
                Choose which recommendations you want included
              </legend>
              <div className="form-group form-check mt-2">
                {talkingPoints.map((talkingPoint) => (
                  <div key={talkingPoint.table.id} className="mb-2">
                    <input
                      id={talkingPoint.table.id}
                      type="checkbox"
                      className="form-check-input"
                      checked={
                        selectedTalkingPointsIds.indexOf(
                          talkingPoint.table.id
                        ) !== -1
                      }
                      onChange={(event) => {
                        // TODO: Extract this
                        const updatedTallkingPointIds = [
                          ...selectedTalkingPointsIds
                        ];
                        if (event.target.checked) {
                          updatedTallkingPointIds.push(talkingPoint.table.id);
                        } else {
                          updatedTallkingPointIds.splice(
                            updatedTallkingPointIds.indexOf(
                              talkingPoint.table.id
                            ),
                            1
                          );
                        }
                        setUserInput({
                          selectedTalkingPointsIds: updatedTallkingPointIds
                        });
                      }}
                    />
                    <label
                      className="form-check-label ml-1"
                      htmlFor={talkingPoint.table.id}
                    >
                      {talkingPoint.table.summary}
                    </label>
                  </div>
                ))}
                {showSelectedTalkingPointsError && (
                  <div className="invalid-feedback d-block">
                    Please select at least one talking point.
                  </div>
                )}
              </div>
            </fieldset>
          )}

          <div className="form-group">
            <label className="h5" htmlFor="message">
              A personal message explaining why this is important to you
            </label>
            <textarea
              id="message"
              name="message"
              className="form-control form-control-sm"
              rows="8"
              placeholder={personalMessagePlaceholder}
              value={personalMessage}
              required
              onChange={(event) =>
                setUserInput({ personalMessage: event.target.value })
              }
            />
          </div>

          {question && question.trim() !== '' ? qa_field : ''}
        </Page>
      </form>
    );
  }
}
